import io from 'socket.io-client';

const room = null;

class Socket
{
    constructor() {
        this.connected = false;
        this.connecting = false;
        this.subscribers = {};
    }

    disconnect() {
        this.socket.disconnect();
    }

    subscribe = (message, callback) => {
        this.subscribers[message] = callback;
    }

    async connect() {
        const url = 'https://care-free.app'

        this.socket = io.connect(url, {
            path:'/server/socket.io',
            transports: ['websocket'],
            reconnection: false,
            timeout: 3000
        });

        this.socket.on('connect', (data) => {
            this.connected = true;
            this.connecting = false;

            pushAlert('Geconnecteerd met chat service!', '#2abc1d', 3000, true);

            if (this.subscribers) {
                Object.keys(this.subscribers).map(key => this.socket.on(key, this.subscribers[key]));
            }
        });
        this.socket.on('error', function (data) {
            this.connected = false;
            this.connecting = false;
            pushAlert('Chat service connectie error! (klik om te connecteren)', '#ff5338', null, true);
        });
        this.socket.on('connect_failed', function (data) {
            this.connected = false;
            this.connecting = false;
            pushAlert('Connecteren met chat service lukt niet! (klik om te connecteren)', '#ff5338', null, true);
        });
        this.socket.on('connect_error', function (data) {
            this.connected = false;
            this.connecting = false;
            pushAlert('Connecteren met chat service lukt niet! (klik om te connecteren)', '#ff5338', null, true);
        });
        this.socket.on('disconnect', function (data) {
            this.connected = false;
            this.connecting = false;
            pushAlert('Gedisconnecteerd van chat service ... (klik om te connecteren)', '#ff5338', null, true);
        });
    }

    join(room) {
        this.socket.emit('join', {room}, () => {});
    }
}

export default Socket;

function pushAlert(msg, color, time, clear){
    console.log(`%cAlert: ${msg}`, 'color: red');
}
